// A term explained on demand (guide 21.7): a small "?" after a word that
// opens its short definition, so a reader new to the scope can follow a
// coordination call. The definitions come from the server (GET /glossary,
// back/utils/glossary) - one list for the view, the estimate and the
// meeting pack.
//
//   <GlossaryTerm id="ezpath" />                 by glossary id
//   <GlossaryTerm rateKey="riser.sleeve" />      the term a production key uses
//   <GlossaryTerm system="telecom" />            the entry for a register system
//   <GlossaryTerm id="idf">IDF 214</GlossaryTerm>  wraps text, "?" after it
import React, { useEffect, useState } from "react";
import { Popover } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { url, tokenRef } from "api";

let cache = null; // Promise<{ terms, rateKeys }>
export function loadGlossary() {
  if (!cache) {
    cache = fetch(`${url}/glossary`, { headers: { Authorization: `Bearer ${localStorage.getItem(tokenRef)}` } })
      .then((r) => (r.ok ? r.json() : { terms: [], rateKeys: {} }))
      .catch(() => { cache = null; return { terms: [], rateKeys: {} }; });
  }
  return cache;
}
export function clearGlossary() { cache = null; }

export function findTerm(g, { id, rateKey, system }) {
  if (!g) return null;
  const want = id || (rateKey && g.rateKeys && g.rateKeys[rateKey]) || "";
  if (want) return (g.terms || []).find((t) => t.id === want) || null;
  if (system) return (g.terms || []).find((t) => (t.systems || []).includes(system)) || null;
  return null;
}

export default function GlossaryTerm({ id, rateKey, system, children }) {
  const [g, setG] = useState(null);
  useEffect(() => { let alive = true; loadGlossary().then((x) => { if (alive) setG(x); }); return () => { alive = false; }; }, []);
  const t = findTerm(g, { id, rateKey, system });
  if (!t) return children || null;
  return (
    <span>
      {children}
      <Popover title={t.term} content={<div style={{ maxWidth: 320 }}>{t.text}</div>} trigger={["hover", "click"]}>
        <QuestionCircleOutlined aria-label={`What is ${t.term}?`} style={{ marginLeft: 4, color: "#71A0B8", cursor: "help", fontSize: 12 }} />
      </Popover>
    </span>
  );
}
